import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import VM from 'scratch-vm';

import ConnectionModal from './connection-modal.jsx';
import RobotConnect from '../components/robot-connect/robot-connect.jsx';
import {closeConnectionModal} from '../reducers/modals';
import {isRobot, panelEnabled} from '../lib/robot-connect.js';

/**
 * 연결 창 갈림길(2026-10-01) — 큐브로이드 로봇이면 "로봇 연결"(그룹 번호 먼저 + 모듈 여러 개를 한 창에서),
 * 그 밖의 장치(micro:bit 등)는 예전 스크래치 연결 창 그대로.
 * 연결 창이 열리는 길(확장 카드 · 카테고리의 ‘!’ · 끊김 알림의 재연결 · 메뉴의 그룹 번호)이 모두 여기를 지난다.
 * 되돌리기: localStorage curoai_robot_panel = '0' → 항상 예전 창(src/lib/robot-connect.js).
 */
const ConnectionGate = props => (
    panelEnabled() && isRobot(props.extensionId) ? (
        <RobotConnect
            focusId={props.extensionId}
            vm={props.vm}
            onClose={props.onClose}
        />
    ) : (
        <ConnectionModal vm={props.vm} />
    )
);

ConnectionGate.propTypes = {
    extensionId: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    extensionId: state.scratchGui.connectionModal.extensionId
});

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeConnectionModal())
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionGate);
